import RestModule from "@/vue-ocom/store/RestModule.js";
import schema from "./schema/index.js";

import { default as NewsModules } from "../news/store";
import { default as MessagingModules } from "../messaging/store";
import { default as NotificationModules } from "../vue-notifications/store";
import DMSModules from "../vue-dms/store";
import FormsModules from "../vue-forms247/app/store";
import { CreatePreferences } from "@/vue-ocom/store/PreferencesModule";
import CreateUserModule from "../vue-ocom/store/CreateUserModule";

import * as CONFIG from "../config.js";

var root_url = CONFIG.root_url;

const UserModule = CreateUserModule(root_url);
const PreferencesModule = CreatePreferences(root_url);

const LeaveRequestModule = RestModule(
  root_url + "/api/leave_request/",
  schema.LeaveRequest
);
const CodeLeaveTypeModule = RestModule(
  root_url + "/api/code_leave_type/",
  schema.CodeLeaveType
);
const BlockOutDateModule = RestModule(
  root_url + "/api/block_out_date/",
  schema.BlockOutDate
);
const CodeLeaveStatusModule = RestModule(
  root_url + "/api/code_leave_status/",
  schema.CodeLeaveStatus
);
const CodeDepotModule = RestModule(
  root_url + "/api/code_depot/",
  schema.CodeDepot
);
const CodeEmployeeTypeModule = RestModule(
  root_url + "/api/code_employee_type/",
  schema.CodeEmployeeType
);
const EmployeeModule = RestModule(root_url + "/api/employee/", schema.Employee);
const LeaveLimitModule = RestModule(
  root_url + "/api/leave_limit/",
  schema.LeaveLimit
);
const EmployeeManagerModule = RestModule(
  root_url + "/api/employee_manager/",
  schema.EmployeeManager
);
const LeaveRequestTypeModule = RestModule(
  root_url + "/api/leave_request_type/",
  schema.LeaveRequestType
);
const LeaveRequestTaskModule = RestModule(
  root_url + "/api/leave_request_task/",
  schema.LeaveRequestTask
);
const CodeEmployeeCategoryModule = RestModule(
  root_url + "/api/code_employee_category/",
  schema.CodeEmployeeCategory
);
const DocumentNotificationRuleModule = RestModule(
  root_url + "/api/document_notification_rule/",
  schema.DocumentNotificationRule
);
const VolunteerShiftModule = RestModule(
  root_url + "/volunteer/volunteer_shift/",
  schema.VolunteerShift
);
//Add more modules here if needed. These will automatically be included and available in main store.

export default {
  UserModule,
  PreferencesModule,

  LeaveRequestModule,
  CodeLeaveTypeModule,
  BlockOutDateModule,
  CodeLeaveStatusModule,
  CodeDepotModule,
  CodeEmployeeTypeModule,
  EmployeeModule,
  LeaveLimitModule,
  EmployeeManagerModule,
  LeaveRequestTypeModule,
  LeaveRequestTaskModule,
  CodeEmployeeCategoryModule,
  DocumentNotificationRuleModule,
  VolunteerShiftModule,
  //Add more modules here
  ...NewsModules,
  ...MessagingModules,
  ...NotificationModules,
  ...DMSModules,
  ...FormsModules,
};
